/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cli_ToolsInputs */



/**
* | output |
* | --- |
* | "CLI Tools" |
*
* @param {Cli_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cli_tools = /** @type {((inputs?: Cli_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cli_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils CLI")
	if (locale === "de") return /** @type {LocalizedString} */ ("CLI-Tools")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti CLI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инструменты командной строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas CLI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("命令行工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CLIツール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CLI उपकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ferramentas de linha de comando")
	return /** @type {LocalizedString} */ ("CLI Tools")
});